import React from 'react';
import {Modal, Button, Alert} from 'react-bootstrap';

interface MailingList {
  id: string;
  adresse: string;
  membres?: string[];
}

interface DeleteMailingListModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  mailingList: MailingList | null;
}

const DeleteMailingListModal: React.FC<DeleteMailingListModalProps> = ({
  show,
  onHide,
  onConfirm,
  mailingList,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  if (!mailingList) return null;

  const hasMembres = mailingList.membres && mailingList.membres.length > 0;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa-solid fa-triangle-exclamation text-warning me-2"></i>
          Confirmer la suppression
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          Êtes-vous sûr de vouloir supprimer la liste de diffusion suivante ?
        </p>

        <Alert variant="secondary" className="border">
          <div className="d-flex align-items-center">
            <i className="fa-solid fa-envelope fs-3 text-primary me-3"></i>
            <div>
              <strong className="d-block text-dark">{mailingList.adresse}</strong>
              {hasMembres && (
                <small className="text-dark">
                  {mailingList.membres!.length} membre(s)
                </small>
              )}
            </div>
          </div>
        </Alert>


        {hasMembres && (
          <Alert variant="warning" className="mb-0 bg-warning bg-opacity-25 text-dark">
            <i className="fa-solid fa-exclamation-triangle me-2"></i>
            <strong>Attention :</strong> Cette liste contient {mailingList.membres!.length} membre(s). 
            Tous les membres seront également supprimés.
          </Alert>
        )}

        {!hasMembres && (
          <Alert variant="info" className="mb-0">
            <i className="fa-solid fa-info-circle me-2"></i>
            Cette liste ne contient aucun membre.
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          <i className="fa-solid fa-times me-2"></i>
          Annuler
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          <i className="fa-solid fa-trash me-2"></i>
          Supprimer définitivement
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteMailingListModal;
